import { ComponentMapping, Container, ContainerState } from '@adobe/aem-react-editable-components'

import { ReactLayoutStyled } from './ReactLayout.styled'
import { HorizontalAlignment, LayoutBackgroundTypes, ReactLayoutProps } from './types'
import './ReactLayout.scss'
import { getSpacing } from '../../utils/spacing-util'
import IsInEditorText from '../shared/IsInEditorText'

class ReactLayout extends Container<ReactLayoutProps, ContainerState> {
  constructor(props: ReactLayoutProps) {
    super(props)
    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping
    }
  }

  displaySection(section: JSX.Element, index: number) {
    const { isInEditor, horizontalAlignment, hideInMobile } = this.props
    const bootstrapGridClass = section.props.bootstrapGridClasses
    const displayClass = hideInMobile ? (index === 1 ? 'd-none d-lg-flex' : 'd-flex') : 'd-flex'
    const horizontalAlignmentClass =
      horizontalAlignment !== HorizontalAlignment.default
        ? `align-items-${HorizontalAlignment[horizontalAlignment as keyof typeof HorizontalAlignment]} text-${
            HorizontalAlignment[horizontalAlignment as keyof typeof HorizontalAlignment]
          }`
        : ''
    return (
      <div
        key={'section-' + index}
        className={`${bootstrapGridClass} ${displayClass} flex-column ${horizontalAlignmentClass}`}
      >
        {isInEditor && <div className='editor-text'>Layout Section {index + 1}</div>}
        {section}
      </div>
    )
  }

  render() {
    const {
      isInEditor = false,
      layoutBackground,
      backgroundColor,
      reverseStacking,
      sideSpace = false,
      borderRadius = false,
      top = false,
      right = false,
      bottom = false,
      left = false,
      lob = ''
    } = this.props
    const reverseStackingClass = reverseStacking ? `flex-lg-row flex-column-reverse` : ''
    const bgColor = layoutBackground === LayoutBackgroundTypes.color ? backgroundColor : ''
    const removeLayoutSectionPadding = sideSpace === true ? 'remove-layout-section-padding' : ''
    const hasBorder = borderRadius === true ? 'bordered' : ''
    return (
      <>
        {IsInEditorText(isInEditor, 'React Layout')}
        <div data-testid='react-layout' className={`react-layout ${getSpacing(top, right, bottom, left)} ${lob}`}>
          <ReactLayoutStyled
            {...this.props}
            className={`row ${bgColor} ${reverseStackingClass} ${removeLayoutSectionPadding} ${hasBorder}`}
          >
            {this.childComponents.map((childComponent, index) => this.displaySection(childComponent, index))}
          </ReactLayoutStyled>
        </div>
      </>
    )
  }
}

export default ReactLayout
